const dimensions = {
  s0: '0',
  s1: '1px',
  s2: '2px',
  s4: '4px',
  s6: '6px',
  s8: '8px',
  s12: '12px',
  s16: '16px',
  s20: '20px',
  s24: '24px',
  s32: '32px',
  s40: '40px',
  s48: '48px',
  s64: '64px',
  s80: '80px',
  s96: '96px',
  s120: '120px',
  s140: '140px',
  s200: '200px',
  s240: '240px',
  s300: '300px',
  s360: '360px',
  s400: '400px',
  s600: '600px',

  // Global sizes
  bannerHeight: '55px',
  sidebarPlaceholder: '16px',
  sidebar: '260px',
  sidebarLogoSize: '120px',
  bodyPadding: '48px',
  widePage: '1600px',
  narrowPage: '936px',
  sidepanelWideXL: '890px',
} as const

export default dimensions

export type Dimensions = keyof typeof dimensions
